var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThanksHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.435,
    height: 47.435,
    viewBox: "0 0 47.435 47.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 0.922,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee6e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7866f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1187",
    "data-name": "Trac\\xE9 1187",
    d: "M11.487,2A2.372,2.372,0,0,0,9.115,4.372V6.743H4.372A2.372,2.372,0,0,0,2,9.115V16.23a9.488,9.488,0,0,0,8.7,9.454,16.62,16.62,0,0,0,12.648,9.351v9.655H18.6a2.372,2.372,0,1,0,0,4.743h14.23a2.372,2.372,0,0,0,0-4.743H28.089V35.036a16.619,16.619,0,0,0,12.648-9.351,9.487,9.487,0,0,0,8.7-9.454V9.115a2.372,2.372,0,0,0-2.372-2.372H42.319V4.372A2.372,2.372,0,0,0,39.948,2ZM6.743,11.487H9.115V18.6a16.792,16.792,0,0,0,.1,1.791A4.742,4.742,0,0,1,6.743,16.23ZM37.576,9.115V6.743H13.859V18.6a11.859,11.859,0,0,0,23.717,0Zm4.743,2.372h2.372V16.23a4.742,4.742,0,0,1-2.467,4.163,16.729,16.729,0,0,0,.1-1.791Zm-16.6,0a4.743,4.743,0,1,0,4.743,4.743A4.743,4.743,0,0,0,25.717,11.487Z",
    transform: "translate(-2 -2)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksHeader);
export default __webpack_public_path__ + "static/media/ThanksHeader.b3a3a595fab0e7459b5ea9c5db734c44.svg";
export { ForwardRef as ReactComponent };